<label
    class="thr-radio-label"
    [attr.for]="inputId"
    [class.thr-radio-checked]="checked"
    [class.thr-radio-disabled]="disabled"
    [style.width]="size + 'px'"
    [style.height]="size + 'px'"
>
    <div class="thr-radio-container">
        <input
            #input
            class="cdk-visually-hidden"
            type="radio"
            [id]="inputId"
            [checked]="checked"
            [disabled]="disabled"
            [attr.name]="name"
            [required]="required"
            (change)="onInputChange($event)"
            (click)="onInputClick($event)"
        />
        <span style="display: none">&nbsp;</span>
        <ng-content></ng-content>
    </div>
    <span class="thr-radio-checked-icon" [style.width]="(size * 18) / 100 + 'px'" [style.height]="(size * 18) / 100 + 'px'">
        <mat-icon [style.font-size]="(size * 10) / 100 + 'px'">check</mat-icon>
    </span>
</label>
